import { SharedItem, SharedItemShareType } from 'services/api/shares';
import { AccessSharingRole } from 'types/entities/AccessSharingRole';

export interface Telematics {
  lastReportTime: string;
  businessUnit: string;
  locationTime: string;
  defRemainingPercent: number;
  fuelRemainingPercent: number;
  extPowerVolts: number;
  hydraulicTempCelsius?: number;
  coolantTempCelsius?: number;
  cumulativeOperatingHours?: number;
  engineRunning?: boolean;
  motionState?: 'moving' | 'in-transport' | 'stationary' | 'unknown';
  restartInhibitStatus?: {
    canModify: boolean;
    commandStatus: string;
    equipmentStatus: string;
    equipmentFeatureStatus: string;
  };
  location?: {
    latitude: number;
    longitude: number;
  };
  faultCodes?: {
    code: number;
    errorType: string;
    description: string;
    timeReported: string;
    j1939Spn?: string;
    j1939Fmi?: string;
  }[];
  smartAttachment?: {
    smartTagSerial?: string;
    model?: string;
    serial?: string;
    modelIconUrl: string;
    //these properties are added just for convenince, they are not comming from the api
    type?: string | 'attachment';
    subcategory?: string | undefined;
    nickName?: string;
    id?: string;
  };
  insideGeofences?: any[];
  electric?: {
    battery: {
      chargerPresent: boolean;
      charging: boolean;
      remainingCharge: number;
      fullCharge: boolean;
      timeUntilFullCharge: number;
    };
    remainingRange: {
      time: number;
      distance: number;
    };
  };
}

export const SUBSCRIPTION_TYPE = {
  INITIAL_TELEMATICS: 'INITIAL_TELEMATICS',
  PREMIUM_TELEMATICS: 'PREMIUM_TELEMATICS',
  SERVICE: 'SERVICE',
} as const;

export type SubscriptionType = keyof typeof SUBSCRIPTION_TYPE;

export interface Subscription {
  name: string;
  type: SubscriptionType;
  endDate?: string;
  nextPaymentDate?: string;
}

export interface IEquipmentEntry {
  id: string;
  // TODO Must be refactored when API is ready.
  role?: AccessSharingRole;
  isSharedIndividually?: boolean;
  isSharedAsPartOfFleet?: boolean;
  dateModified: string;
  modelIconUrl: string;
  modelFullUrl: string;
  modelHeroUrl: string;
  serial: string;
  nickName?: string;
  model: string;
  type?: 'machine' | 'attachment';
  pinOrSerial: string;
  identifierType: string;
  hasTelematics: boolean;
  hasFaultCodes: boolean;
  userEnteredEngineHours?: number;
  subcategory: string;
  warrantyUrl: string;
  manualEntries: any[];
  videoEntries: any[];
  guideUrl: string;
  hasMaintenanceSchedules: boolean;
  telematics?: Telematics;
  smartAttachment?: {
    tagSerial?: string;
    tagStartDate?: string;
  };
  subscriptions: Subscription[];
  updated: boolean;
}

export interface ISharedEquipmentEntry extends IEquipmentEntry {
  shareData?: SharedItem;
  fleetData?: SharedItem;
}

export interface ISharedUser {
  email: string;
  displayName: string;
  role: string;
  sharedEquipments: SharedItem[];
  sharedFleets: SharedItem[];
}

export interface IOperatorDetails {
  exposedId: string;
  exposedAccessSharingRecordId: string;
  sharedItemLabel: string;
  type: SharedItemShareType;
  role: string;
  startTime: string;
  endTime: string;
  details: {
    model?: string;
    pinOrSerial?: string;
    equipmentCount?: number;
  };
}
